import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Box, Stack, Heading, Text } from '@chakra-ui/react';
var QUESTIONS = [{
  title: "What is the 'Full Service' package?",
  text: "With 'Full Service' we take care of complete setup for your Publication Hub. After you supply us with the authors you wish to follow (via email or your faculty page) we will add them to the platform. " + 'It takes us up to 4 business day to complete your setup. ' + "We offer the 'Full Service' as an additional service with one time fee. The service is completely optional, and you can absolutely setup you Publications Hub your self."
}, {
  title: 'What is a publisher?',
  text: 'Publisher is person you want to show his publications in your Publication hub.'
}, {
  title: 'How many publishers can I have?',
  text: "You can have as many publishers as you'd like. Every licence you buy grants you another publisher we track. Please visit our pricing to see the plans and latest pricing."
}, {
  title: 'How many articles can I have in the publication hub?',
  text: 'The more the marrier! We do not put any limit on the number of publication in your hub. You decide how far back you want us to search for articles. There is not limit nor on a single publisher, nor on the number of articles for your organization.'
}, {
  title: 'How long does it take for an article to appear in the publication hub?',
  text: 'We usually gets the article up to a week after it available online. In some cases it may take longer.'
}, {
  title: 'How do you get the articles?',
  text: 'We scan and index online public scholar data to get past and new articles and publications. To be able to fetch articles, the publisher must have a Google Scholar profile.'
}, {
  title: 'Why do I need to pay setup fee?',
  text: 'We strive to make our services as affordable as possible. The initial indexing process is time and compute cosuming. We go as far back as possible for each publisher you have, and get the details for every article avaialble. ' + 'This step is essential for any Publication Hub and we cannot skip it.'
}, {
  title: 'What are subscribers?',
  text: 'Through your publication hub, visitors can subscribe to updates. We will automatically send them updates on new published articles. Your reserachers, stundents and colleagues can subscribe. That way you keep everybody up to date with your latest work effortlessly.'
}, {
  title: 'What payment methods are available?',
  text: 'We accept credit card payments, ACH and bank transfers (also called Wire). If you wish to pay with ACH or Wire, please contact us via chat or e-mail us at: support@articali.app.'
}];
export default function FAQ() {
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: "10",
    children: [/*#__PURE__*/_jsxs(Stack, {
      children: [/*#__PURE__*/_jsx(Heading, {
        textAlign: "center",
        children: "Frequently asked questions"
      }), /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        mb: "8",
        children: "We gathered common questions for you. If you have another question, feel free to chat with us!"
      })]
    }), /*#__PURE__*/_jsx(Accordion, {
      children: QUESTIONS.map(function (item, i) {
        return /*#__PURE__*/_jsxs(AccordionItem, {
          py: 3,
          children: [/*#__PURE__*/_jsx("h2", {
            children: /*#__PURE__*/_jsxs(AccordionButton, {
              children: [/*#__PURE__*/_jsx(Box, {
                flex: "1",
                textAlign: "left",
                fontWeight: "bold",
                children: item.title
              }), /*#__PURE__*/_jsx(AccordionIcon, {})]
            })
          }), /*#__PURE__*/_jsx(AccordionPanel, {
            lineHeight: "30px",
            children: item.text
          })]
        }, i);
      })
    })]
  });
}